module.exports = __webpack_public_path__ + "static/availability-14b34b283ccb42572f87f35c52032c41.jpg";